module.exports = __webpack_public_path__ + "img/pay-7.5f10805f.png";